import { AnyAction } from 'redux';
// Import custom modules
import ActionTypes from '../../actionTypes';

export function resetReducerToInitialState(): AnyAction {
  return {
    type: ActionTypes.resetReducerToInitialState,
  };
}
